module.exports = __webpack_public_path__ + "static/img/5.5c3adb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zeus/5.png
// module id = vHXt
// module chunks = 0